(function () {
  function initReveal() {
    var els = document.querySelectorAll('.pa-reveal:not(.pa-visible)');
    if (!els.length) return;
    var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('pa-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('pa-visible');
        obs.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  function cambiarFoto(principal, src, alt) {
    principal.style.opacity = 0;
    var img = new Image();
    img.onload = function () {
      principal.src = img.src;
      principal.removeAttribute('srcset');
      principal.alt = alt || '';
      principal.style.opacity = 1;
    };
    img.onerror = function () { principal.style.opacity = 1; };
    img.src = src;
  }

  function initGaleria(raiz) {
    var principal = raiz.querySelector('[data-pa-principal]');
    var minis = raiz.querySelectorAll('[data-pa-mini]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        cambiarFoto(principal, mini.getAttribute('data-src'), mini.getAttribute('data-alt'));
        minis.forEach(function (m) { m.setAttribute('aria-current', m === mini ? 'true' : 'false'); });
      });
    });
  }

  function initProducto() {
    var raiz = document.querySelector('[data-pa-producto]');
    if (!raiz) return;
    initGaleria(raiz);

    var packs = raiz.querySelector('[data-pa-packs]');
    function aplicarPack() {
      if (!packs) return;
      var elegido = packs.querySelector('input[data-pa-pack]:checked');
      var n = elegido ? parseInt(elegido.value, 10) || 1 : 1;
      var cantidad = raiz.querySelector('[data-pa-cantidad]');
      if (cantidad) cantidad.value = n;
      var precio = raiz.querySelector('[data-pa-dinamico] .pa-compra__precio span');
      if (precio) {
        if (!precio.hasAttribute('data-original')) precio.setAttribute('data-original', precio.textContent.trim());
        var precioPack = elegido && elegido.getAttribute('data-pa-precio');
        precio.textContent = n > 1 && precioPack ? precioPack : precio.getAttribute('data-original');
      }
      var boton = raiz.querySelector('[data-pa-dinamico] button[name="add"]');
      if (!boton || boton.disabled) return;
      if (!boton.hasAttribute('data-texto')) boton.setAttribute('data-texto', boton.textContent.trim());
      var plantilla = packs.getAttribute('data-boton-pack');
      boton.textContent = n > 1 && plantilla ? plantilla.replace('[n]', n) : boton.getAttribute('data-texto');
    }
    if (packs) packs.addEventListener('change', aplicarPack);
    aplicarPack();

    var opciones = raiz.querySelector('[data-pa-opciones]');
    if (!opciones) return;
    var peticion = 0;

    function pintarColor() {
      var marcado = opciones.querySelector('input[data-pa-hex]:checked');
      if (marcado) raiz.style.setProperty('--pa-acento', marcado.getAttribute('data-pa-hex'));
      opciones.querySelectorAll('[data-pa-opcion]').forEach(function (grupo) {
        var salida = grupo.querySelector('[data-pa-elegido]');
        var input = grupo.querySelector('input:checked');
        if (salida && input) salida.textContent = input.getAttribute('data-pa-nombre') || input.value;
      });
    }

    function idsElegidos() {
      var ids = [];
      opciones.querySelectorAll('[data-pa-opcion]').forEach(function (grupo) {
        var input = grupo.querySelector('input:checked');
        var select = grupo.querySelector('select');
        if (input) ids.push(input.getAttribute('data-pa-valor'));
        else if (select) ids.push(select.options[select.selectedIndex].getAttribute('data-pa-valor'));
      });
      return ids;
    }

    function nombresElegidos() {
      var nombres = [];
      opciones.querySelectorAll('[data-pa-opcion]').forEach(function (grupo) {
        var input = grupo.querySelector('input:checked');
        var select = grupo.querySelector('select');
        if (input) nombres.push(input.value);
        else if (select) nombres.push(select.value);
      });
      return nombres;
    }

    function pintarFoto(input) {
      var principal = raiz.querySelector('[data-pa-principal]');
      var src = input && input.getAttribute && input.getAttribute('data-pa-foto');
      if (!principal || !src) return;
      cambiarFoto(principal, src, input.getAttribute('data-pa-nombre'));
      raiz.querySelectorAll('[data-pa-mini]').forEach(function (m) { m.setAttribute('aria-current', 'false'); });
    }

    function actualizar(evento) {
      pintarColor();
      if (evento) pintarFoto(evento.target);
      var dinamico = raiz.querySelector('[data-pa-dinamico]');
      if (!dinamico) return;
      var turno = ++peticion;
      dinamico.setAttribute('aria-busy', 'true');
      var url = raiz.getAttribute('data-url') + '?option_values=' + idsElegidos().join(',') + '&section_id=' + raiz.getAttribute('data-seccion');
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (turno !== peticion) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nuevo = doc.querySelector('[data-pa-dinamico]');
          if (!nuevo) return;
          dinamico.innerHTML = nuevo.innerHTML;
          var id = dinamico.querySelector('input[name="id"]');
          // Si la combinación elegida no existe, la tienda devuelve otra variante: no dejar comprarla
          var real = nuevo.getAttribute('data-pa-variante');
          if (real !== null && real !== nombresElegidos().join('||')) {
            var boton = dinamico.querySelector('button[name="add"]');
            if (boton) {
              boton.disabled = true;
              boton.textContent = nuevo.getAttribute('data-pa-agotado') || boton.textContent;
            }
            if (id) id.value = '';
            var aviso = dinamico.querySelector('.pa-aviso');
            if (aviso) aviso.textContent = nuevo.getAttribute('data-pa-nota-agotado') || '';
            return;
          }
          aplicarPack();
          if (id && id.value && window.history.replaceState) {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', id.value);
            window.history.replaceState({}, '', u.toString());
          }
        })
        .catch(function () {})
        .then(function () { if (turno === peticion) dinamico.removeAttribute('aria-busy'); });
    }

    opciones.addEventListener('change', actualizar);
    pintarColor();
  }

  function init() {
    document.documentElement.classList.remove('pa-sin-js');
    initReveal();
    initProducto();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
